import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import Summaries from "examples/Summaries";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Footer from "examples/Footer";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useMaterialUIController } from "context";

function Reports() {
  const [controller] = useMaterialUIController();
  const { accounts } = controller;
  const [years] = useState(["2025", "2024", "2023", "2022", "2021", "2020", "2019"]);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    setSelectedAccount(accounts[0]);
  }, [accounts]);

  const handleAccountChange = (event, newValue) => {
    setSelectedAccount(newValue);
  };

  const handleYearChange = (event, newValue) => {
    setSelectedYear(newValue);
  };

  const handleSetTabValue = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3} mt={-3} alignItems="center">
          <Grid item xs={12} md={6} lg={6} sx={{ ml: "auto" }}>
            <AppBar position="static">
              <Tabs value={tabValue} onChange={handleSetTabValue} aria-label="reports tabs">
                <Tab label="Outcome" icon={<Icon fontSize="small" sx={{ mt: -0.25 }}>logout</Icon>} />
                <Tab label="Income" icon={<Icon fontSize="small" sx={{ mt: -0.25 }}>login</Icon>} />
                <Tab label="Balance" icon={<Icon fontSize="small" sx={{ mt: -0.25 }}>balance</Icon>} />
                <Tab label="Snapshot" icon={<Icon fontSize="small" sx={{ mt: -0.25 }}>monetization_on</Icon>} />
              </Tabs>
            </AppBar>
          </Grid>
        </Grid>
        <MDBox display="flex" alignItems="center" p={2}>
          <MDBox width="200px">
          <Autocomplete
            options={accounts}
            getOptionLabel={(option) => option.name}
            value={selectedAccount}
            onChange={handleAccountChange}
            isOptionEqualToValue={(option, value) => value === null || option.id === value.id}
            renderInput={(params) => (<TextField {...params} label="All accounts" variant="outlined" />)}
          />
          </MDBox>
          <MDBox width="200px" ml={1}>
          <Autocomplete
            options={years}
            value={selectedYear || null}
            onChange={handleYearChange}
            renderInput={(params) => (<TextField {...params} label="All years" variant="outlined" />)}
          />
          </MDBox>
        </MDBox>
        {tabValue === 0 && <Summaries selectedYear={selectedYear} selectedAccount={selectedAccount} title="Outcome" />}
        {tabValue === 1 && <Summaries selectedYear={selectedYear} selectedAccount={selectedAccount} title="Income" color="success" type="income" categories={["salary", "extra"]} />}
        {tabValue === 2 && <Summaries selectedYear={selectedYear} selectedAccount={selectedAccount} title="Balance" color="info" type="balance" categories={["balance"]} />}
        {tabValue === 3 && <Summaries selectedYear={selectedYear} selectedAccount={selectedAccount} title="Snapshot" color="primary" type="first_day_snapshot" categories={["total"]} direction={1} />}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Reports;
